<template>
  <div ref="a4" class="blank-page">
    <template v-if="selected_signs.length == 0" >
        <div v-for="index in pages" :key="index" class="wrapper" :class="{break:index > 0}">
            <div class="sign">
                <SignSaleForOnePageCatalogy />
            </div>
        </div>
    </template>
    <template v-else>
        <div v-for="(page,index) in pagination.pages" :key="page" class="wrapper" :class="{break:index > 0}">
            <template v-for="sign in pagination.signs[index]" :key="sign.duplicate_inx || sign.promoCode">
                <div class="sign">
                    <SignSaleForOnePage :sign="sign" />
                </div>
            </template>
        </div>
    </template>
  </div>
</template>

<script>
import { ref } from '@vue/reactivity'
import {is_sales_print,pagination_signs} from '../Scripts/scripts'
import {is_deleted, printer_amount,selected_deals} from '../components/Deals/Scripts/store'
import { defineAsyncComponent, watch } from '@vue/runtime-core'

export default {
    props:['pages','selected_signs'],
    components:{
        SignSaleForOnePage:defineAsyncComponent(() => import('./components/SignSaleForOnePage.vue')),
        SignSaleForOnePageCatalogy:defineAsyncComponent(() => import('../components/ShilutCatalogy/SignSaleForOnePageCatalogy.vue')),
    },
    setup(props){

        const {organise_signs,pagination} = pagination_signs()
        const a4 = ref()

        /*
            שלט שלם מבצע חם:
            מודפס על נייר ממותג - התוכן חייב להישאר בין 6 ס"מ מלמעלה ל-3 ס"מ מלמטה.
            השוליים נאכפים דרך @page margin וגובה קבוע ל-wrapper עם overflow:hidden
            כך שהתוכן לא יכול לחרוג מהאזור המותר.
        */
        const handle_print = () => {
            var styleElem = document.createElement('style');
            styleElem.type = 'text/css' ;
            var css = `
                @import url('https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500&display=swap');
                *{
                    direction:rtl;
                    font-family: 'Rubik', sans-serif;
                    font-weight:normal;
                    padding:0;
                    margin:0;
                    box-sizing: border-box;
                }
                @media print {
                    .no-see-in-print{
                        display:none;
                    }
                    .float-icon{
                        display:none;
                    }
                    .add-icon,.clean-icon{
                        display:none;
                    }
                    .break{
                        page-break-before: always;
                    }
                }
                @page {
                    size: A4;
                    margin: 0;
                }
                .blank-page{
                    width: 100%;
                }
                .wrapper{
                    width: 100%;
                    /* עמוד A4 מלא (עם מרווח ביטחון קטן) - השוליים הם חלק מהתוכן עצמו
                       ולכן לא תלויים בהגדרות השוליים של דיאלוג ההדפסה */
                    height: 29.6cm;
                    padding: 6cm 0.5cm 3cm 0.5cm;
                    overflow: hidden;
                }

                .wrapper .sign{
                    width: 100%;
                    height: 100%;
                }

               .sign-sale{
                    width: 100%;
                    height: 100%;
                }
                .sign-sale-header{
                    position: relative;
                    width: 100%;
                    height: 4%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 24px;
                    text-align: center;
                }
                .prormo-limit{
                    width: 100%;
                    font-size: 20px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                .logo{
                    position: absolute;
                    width: 100px;
                    height: 100%;
                    top: 5px;
                    left: 5px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                .logo img{
                    width: 100px;
                    height: 50px;
                }
                .sign-sale-input-texts{
                    position: relative;
                    width: 100%;
                    height: 34%;
                    font-size: 40px;
                }
                .sign-sale-input-texts .he,.sign-sale-input-texts .ru{
                    width: 100%;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    text-align: center;
                    font-size: 40px;
                    padding: 0 10px;
                }

                .sign-sale-input-texts .ru{
                    font-size: 28px;
                }

                .float-icon{
                    position: absolute;
                    top: 0;
                    right: 5px;
                }
                .add-icon,.clean-icon{
                    color: var(--success);
                    cursor: pointer;
                    font-size: 35px;
                    user-select: none;
                }
                .clean-icon{
                    color: var(--danger);
                }
                .sign-sale-contents{
                    width: 100%;
                    height: 42%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    align-content: center;
                    flex-wrap: wrap;
                    gap: 15px;
                    font-size: 60px;
                }
                .col{
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                }
                .sign-sale-contents > .col{
                    height: auto;
                }
                .col.middle{
                    width: 10%;
                    font-size: 28px;
                    align-items: flex-end;
                }
                .col.barcodes{
                    width: 80%;
                    height: max-content;
                    flex-direction: row;
                    justify-content: flex-start;
                    flex-wrap: nowrap;
                    overflow-x: auto;
                    overflow-y: hidden;
                    padding: 0px 20px;
                }
                .col.barcodes > div{
                    display: flex;
                    align-items: center;
                    width: 100%;
                    padding: 0px 20px;
                }
                .grams{
                    font-size: 22px;
                }

                .col.small{
                    font-size: 32px;
                    text-align: center;
                }
                .sign-sale-contents > .col:first-child{
                    font-size: 32px;
                }
                .sign-sale-contents > .col:last-child{
                    width: 100%;
                    font-size: 85px;
                }
                .sign-sale-footer{
                    width: 100%;
                    height: 20%;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    padding: 5px;
                    overflow: hidden;
                }
                 .sign-sale-footer.item-error{
                    justify-content: center;
                    align-items: center;
                    color: red;
                }
                .col.price{
                    width: 100%;
                    font-size: 28px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    text-align: center;
                    order: 1;
                    padding: 2px 0;
                }
                .col.price > small{
                    font-weight: 500;
                    font-size: 36px;
                    white-space: nowrap;
                }
                .col.barcodes{
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    order: 2;
                    gap: 5px;
                }
                    .col.barcodes h1 {
                        font-size: 18px;
                    }
                [data-slice]{
                    white-space: nowrap;
                    overflow: hidden;
                    margin-right: 5px;
                    font-size: 18px;
                }
                [data-fixed]{
                    display: flex;
                    align-items: center;
                    font-size: 20px;
                }

                .choos-item{
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background: var(--main);
                    z-index: 1000;
                }
                .slide-in-top {
                -webkit-animation: slide-in-top 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
                        animation: slide-in-top 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
                }

                @-webkit-keyframes slide-in-top {
                0% {
                    -webkit-transform: translateY(-1000px);
                            transform: translateY(-1000px);
                    opacity: 0;
                }
                100% {
                    -webkit-transform: translateY(0);
                            transform: translateY(0);
                    opacity: 1;
                }
                }
                @keyframes slide-in-top {
                0% {
                    -webkit-transform: translateY(-1000px);
                            transform: translateY(-1000px);
                    opacity: 0;
                }
                100% {
                    -webkit-transform: translateY(0);
                            transform: translateY(0);
                    opacity: 1;
                }
                }

            `
            if(styleElem.styleSheet){
                styleElem.styleSheet.cssText = css;
            }
            else{
                styleElem.appendChild(document.createTextNode(css));
            }
            let newWin= window.open('', '', 'height=500, width=500');
            newWin.document.write(a4.value.outerHTML);
            newWin.document.getElementsByTagName('head')[0].appendChild(styleElem);
            newWin.document.close();
            setTimeout(() => {
                is_sales_print.value = false
                newWin.print();
            },1000)
        }

        const handle_print_catalogy = () => {
            var styleElem = document.createElement('style');
            styleElem.type = 'text/css' ;
            var css = `
                @import url('https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500&display=swap');
                *{
                    direction:rtl;
                    font-family: 'Rubik', sans-serif;
                    font-weight:normal;
                    padding:0;
                    margin:0;
                    box-sizing: border-box;
                }
                @media print {
                    .no-see-in-print{
                        display:none;
                    }
                    .float-icon{
                        display:none;
                    }
                    .add-icon,.clean-icon{
                        display:none;
                    }
                    .break{
                        page-break-before: always;
                    }
                }
                @page {
                    size: A4;
                    margin: 0;
                }
                .blank-page{
                    width: 100%;
                }
                .wrapper{
                    width: 100%;
                    height: 29.6cm;
                    padding: 6cm 0.5cm 3cm 0.5cm;
                    overflow: hidden;
                }
                .wrapper .sign{
                    width: 100%;
                    height: 100%;
                }
               .sign-sale{
                    width: 100%;
                    height: 100%;
                }
                .sign-sale-header{
                    position: relative;
                    width: 100%;
                    height: 10%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 26px;
                    border-bottom: 1px solid black;
                    text-align: center;
                }
                .prormo-limit{
                    height: 5%;
                    width: 100%;
                    font-size: 20px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                .logo{
                    position: absolute;
                    width: 100px;
                    height: 100%;
                    top: 5px;
                    left: 5px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                .logo img{
                    width: 100px;
                    height: 50px;
                }
                .sign-sale-input-texts{
                    position: relative;
                    width: 100%;
                    height: 38%;
                    font-size: 36px;
                }
                .sign-sale-input-texts .he,.sign-sale-input-texts .ru{
                    width: 100%;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    text-align: center;
                    font-size: 48px;
                    padding: 0 10px;
                }
                .sign-sale-input-texts .ru{
                    font-size: 26px;
                }
                .sign-sale-contents{
                    width: 100%;
                    height: 37%;
                    font-size: 56px;
                }
                .col{
                    width: 100%;
                    height: calc(100% / 3);
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                }
                .col.middle{
                    width: 10%;
                    font-size: 26px;
                    align-items: flex-end;
                }
                .col.barcodes{
                    align-items:unset;
                    padding: 0 5px;
                    width: 40%;
                }
                .col.barcodes > div{
                    display: flex;
                    align-items: center;
                    width: 100%;
                }
                .col.price{
                    width: 50%;
                    flex-direction: column;
                }
                .col.price > *{
                    font-weight: 400;
                }
                .grams{
                    font-size: 22px;
                }
                .col.small{
                    font-size: 56px;
                    text-align: center;
                }
                .sign-sale-footer{
                    width: 100%;
                    height: 10%;
                    display: flex;
                    align-items: center;
                    overflow: hidden;
                }
                 .sign-sale-footer.item-error{
                    justify-content: center;
                    align-items: center;
                    color: red;
                }
                [data-slice]{
                    white-space: nowrap;
                    overflow: hidden;
                    margin-right: 5px;
                }
                [data-fixed]{
                    display: flex;
                    align-items: center;
                }
                .choos-item{
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background: var(--main);
                    z-index: 1000;
                }
            `
            if(styleElem.styleSheet){
                styleElem.styleSheet.cssText = css;
            }
            else{
                styleElem.appendChild(document.createTextNode(css));
            }
            let newWin= window.open('', '', 'height=500, width=500');
            newWin.document.write(a4.value.outerHTML);
            newWin.document.getElementsByTagName('head')[0].appendChild(styleElem);
            newWin.document.close();
            setTimeout(() => {
                is_sales_print.value = false
                newWin.print();
            },1000)
        }

        if(props.selected_signs && props.selected_signs.length > 0){
            organise_signs(1,props.selected_signs)
        }

        printer_amount.value = []
        is_deleted.value = false
        watch(is_sales_print,()=>{
            if(is_sales_print.value && props.selected_signs.length > 0){
                setTimeout(() => {
                    handle_print()
                }, 500);
            }
            else if(is_sales_print.value && props.selected_signs.length == 0){
                 setTimeout(() => {
                    handle_print_catalogy()
                }, 500);
            }
        })

        watch(selected_deals.value,()=>{
            organise_signs(1,selected_deals.value)
        })
        return{
            handle_print,
            pagination,
            a4,
        }
    }
}
</script>

<style scoped>
    .blank-page{
        width: 100%;
        min-height: 100%;
        background: #fff;
        padding: 5px;
    }
    /* תצוגה מקדימה התואמת להדפסה: 6 ס"מ שמורים למעלה ו-3 ס"מ למטה */
    .wrapper{
        position: relative;
        width: 100%;
        height: 297mm;
        padding: 60mm 5mm 30mm 5mm;
    }
    .wrapper::before{
        content: 'אזור שמור - 6 ס"מ עליונים (לא מודפס)';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 60mm;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #b5b5b5;
        font-size: 20px;
        border-bottom: 2px dashed #ff6347;
    }
    .wrapper::after{
        content: 'אזור שמור - 3 ס"מ תחתונים (לא מודפס)';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 30mm;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #b5b5b5;
        font-size: 20px;
        border-top: 2px dashed #ff6347;
    }
    .wrapper .sign{
        width: 100%;
        height: 100%;
        border:1px solid black;
    }


</style>
